define('jquery',['require'],function(require) {

    'use strict';

    window.$ = window.$ || window.jQuery;

    return window.jQuery;

});
